'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const styled = require('styled-components');
const styled__default = _interopDefault(styled);

// Returns a wrapper for the SVG
var IconWrapper = styled__default.svg.withConfig({
  displayName: "iconstyle__IconWrapper",
  componentId: "sc-12jucjo-0"
})(["pointer-events:none;width:", ";height:", ";display:inline-block;overflow:visible;path{fill:", ";}rect{fill:", ";stroke:", ";}fill:", ";stroke:", ";"], function (_ref) {
  var $sizeStyle = _ref.$sizeStyle;
  return $sizeStyle;
}, function (_ref2) {
  var $sizeStyle = _ref2.$sizeStyle;
  return $sizeStyle;
}, function (_ref3) {
  var fill = _ref3.fill;
  return fill;
}, function (_ref4) {
  var fill = _ref4.fill;
  return fill;
}, function (_ref5) {
  var fill = _ref5.fill;
  return fill;
}, function (_ref6) {
  var fill = _ref6.fill;
  return fill;
}, function (_ref7) {
  var fill = _ref7.fill;
  return fill;
});

exports.IconWrapper = IconWrapper;
